<template>
  <div class="wrapper">
    <div class="container">
      <img src="../assets/images/icon-success.png" class="icon" />
      <h3>恭喜您，获取成功！<br/> 请您按照提示在微信完成实名认证，<br/>并设置登录邮箱和密码。</h3>
      <!-- <router-link :to="{}" class="btn active-btn">如何设置登录邮箱和密码？</router-link> -->
      <a href="https://kf.qq.com/faq/200703maI3qE200703FnaeeY.html" class="btn active-btn">如何设置登录邮箱和密码？</a>
      <router-link :to="{path: '/auth-succes', query: {shopCode: shopCode}}" class="btn">查看授权二维码</router-link>
      <!-- <router-link :to="{path: '/register-mp', query: {shopCode: shopCode}}" class="btn">现在就去设置小程序信息</router-link>
      <p>您也可以以后通过公众号的「设置小程序信息」进行设置~</p> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'storeList',
  data() {
    return {
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      shopCode: null,
      wechat: ''
    }
  },
  created() {
    if(this.$route.query){
      this.shopCode = this.$route.query.shopCode;
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.container{
  height: 100%;
  .icon{
    width: 60px;
    height: 60px;
    display: block;
    margin: 114px auto 0;
  }
  h3{
    width: 100%;
    line-height: 1.4;
    font-size: 18px;
    color: #222;
    text-align: center;
    margin: 24px 0 44px;
  }
  .btn{
    width: 90%;
    max-width: 300px;
    height: 48px;
    line-height: 48px;
    border-radius: 10px;
    background: #fff;
    font-size: 16px;
    color: #222;
    text-align: center;
    margin: 20px auto;
    display: block;
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid #D8E0F0;
  }
  .active-btn{
    background: #47B6C7;
    color: #fff;
    border: 0;
  }
  p{
    line-height: 1.4;
    font-size: 12px;
    color: #666;
    text-align: center;
    margin-top: 10px;
  }
}
.section{
  margin: 0 38px;
  .lable-name{
    line-height: 32px;
    font-size: 14px;
    color: #8F8F94;
    text-align: left;
  }
  .wechat{
    width: 100%;
    line-height: 20px;
    padding: 15px 10px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #D8E0F0;
    font-size: 18px;
    color: #222;
    text-align: left;
    border: 1px solid #D8E0F0;
  }
}
@media screen and (max-width:750px){
  .container{
    width: 94%;
    margin: 0 3%;
  }
}
@media screen and (min-width:750px){
  
}
</style>


// WEBPACK FOOTER //
// src/views/result.vue